import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route} from "react-router-dom";
import Homepage from './components/Homepage';
import IndexPage from './components/Index';
import Admin from './components/forms/admin';
import ContactPage from './components/Contact';
import Header from './components/common/header/header';
import AkaSearch from './components/search/akaSearch';
import AkaResponse from './components/responses/akaResponse';
import HistoryResponse from './components/responses/historyResponse';
import StatusSearch from './components/search/statusSearch';
import StatusResponse from './components/responses/statusResponse';
import InquirySearch from './components/search/inquirySearch';
import { AuthProvider, useAuth } from './context/AuthContext';
import About from './About';
import NotFound from './NotFound';
import Login2 from './components/login/login';
import Footer from './components/common/footer/footer';
import HistorySearch from './components/search/historySearch';
import InquiryResponse from './components/responses/inquiryResponse';
import QueryFiltersPage from './components/queryFilters';
import VehicleResponse from './components/responses/vehicleResponse';
import VehicleSearch from './components/search/mexicoSearch';
import MinimalSearch from './components/search/minimalSearch';
import UploadBatch from './components/common/batch/upload';
import BatchQueue from './components/common/batch/queue';
import CallbackLoginGov from './components/callback/CallbackLoginGov';
import CallbackMyAccess from './components/callback/CallbackMyAccess';
import Reports from './components/reports/reports';
import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import MinimalResponse from './components/responses/minimalResponse';
import Banner from './components/forms/banner';
import Banner1 from './components/forms/banner1';
import Banner2 from './components/forms/banner2';
import Banner3 from './components/forms/banner3';
import Banner4 from './components/forms/banner4';
import Banner5 from './components/forms/banner5';
import Banner6 from './components/forms/banner6';
import Messages from './components/forms/msgs'
import Loading from './components/Loading';
import { setIsTestEnv } from './utils/data';

function AppContent() {
  const { isAuthenticated, logout } = useAuth();
  const [showWarning, setShowWarning] = useState(false);
  const [countdown, setCountdown] = useState(120); // 2 minutes
  const [announce, setAnnounce] = useState([]);
  const [alerts, setAlerts]  = useState([]);

  const time = new Date().getTime();
  //const alerts = [];

  const toEpoch = (d) => {
    return new Date(d).getTime();
  }


  useEffect(() => {
    
    const fullUrl = window.location.href;
    console.log("Full url: ", fullUrl)
    setIsTestEnv((fullUrl.includes('cdlis-dev') || fullUrl.includes('cdlis-int') || fullUrl.includes('cdlis-stg') || fullUrl.includes('local')))
    async function fetchData() {
      try {
        //if(alerts.length > 0){return}
        const response = await fetch('/api/system/banner/getmessages');
        if (!response.ok) throw new Error('Failed to fetch');
        
        const data = await response.json(); 
        console.log("Data received for banner", data?.responseData)
        setAnnounce(data?.responseData?.alert.cdlis)

      } catch (error) {
        console.error("Error fetching banner:", error);
      }
    } fetchData();
  }, []);

  useEffect(() => {
    let logoutTimer, warningTimer, countdownTimer;

    const resetTimer = () => {
      setShowWarning(false);
      clearTimeout(logoutTimer);
      clearTimeout(warningTimer);
      clearInterval(countdownTimer);

      // Show modal at 13 minutes
      warningTimer = setTimeout(() => {
        setShowWarning(true);

        // Start countdown for 2 mins
        setCountdown(120);
        countdownTimer = setInterval(() => {
          setCountdown(prev => {
            if (prev <= 1) {
              clearInterval(countdownTimer);
            }
            return prev - 1;
          });
        }, 1000);
      }, 13 * 60 * 1000); // 13 minutes

      // Logout at 15 minutes
      logoutTimer = setTimeout(() => {
        setShowWarning(false);
        logout();
      }, 15 * 60 * 1000);
    };

    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);
    resetTimer();

    return () => {
      clearTimeout(logoutTimer);
      clearTimeout(warningTimer);
      clearInterval(countdownTimer);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keydown', resetTimer);
    };
  }, [isAuthenticated, logout]);

  useEffect(() => {

     async function populate(){
      setAlerts(announce);
    } populate()
  }, [announce]);

  return (
    <>
      <Header />
      <body className="container-fluid" id='App-body'>
      {alerts && 
        <>
          {alerts.map((message) => (
            <div class="alert alert-danger" role="alert">
                <strong>{message}</strong>
            </div>
          ))}
        </>
      }
      <Routes>
        <Route path="/login2" element={<Login2 />} />
        <Route path="/about" element={<About />} />
        <Route path="/logindotgov/authorization-code/callback" element={<CallbackLoginGov />} />
        <Route path="/myaccess/authorization-code/callback" element={<CallbackMyAccess />} />
        <Route path="/" element={<IndexPage />} />
       {/* <Route path="/login" element={<LoginPage />} />*/} 
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/akasearch" element={<AkaSearch />} />
        <Route path="/akaresults" element={<AkaResponse />} />
        <Route path="/historysearch" element={<HistorySearch />} />
        <Route path="/historyresults" element={<HistoryResponse />} />
        <Route path="/statussearch" element={<StatusSearch />} />
        <Route path="/statusresults" element={<StatusResponse />} />
        <Route path="/inquirysearch" element={<InquirySearch />} />
        <Route path="/inquiryresults" element={<InquiryResponse />} />     
        <Route path="/queryfilters" element={<QueryFiltersPage />} />        
        <Route path="/vehicleresults" element={<VehicleResponse />} />        
        <Route path="/vehiclesearch" element={<VehicleSearch />} /> 
        <Route path="/minimalresults" element={<MinimalResponse />} />        
        <Route path="/minimalsearch" element={<MinimalSearch />} /> 
        <Route path="/uploadbatch" element={<UploadBatch />} />  
        <Route path="/batchqueue" element={<BatchQueue />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/admin" element={<Admin /> } />
        <Route path="/banner" element={<Banner /> } />
        <Route path="/messages" element={<Messages /> } />
        <Route path="*" element={<NotFound />} />
      </Routes>
      </body>
      <Footer /> {/* Conditionally render the Footer */}

      <Modal show={showWarning} onHide={() => setShowWarning(false)} centered>
        <Modal.Header>
          <Modal.Title>Session Timeout Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          You will be logged out due to inactivity in <strong>{countdown}</strong> seconds.
          Please move your mouse to remain logged in.
        </Modal.Body>
      </Modal>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}
